import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 220px)', // Account for header/footer
      padding: '24px',
      textAlign: 'center'
    }}>
      <div style={{
        fontSize: '120px',
        fontWeight: 'bold',
        color: '#003366',
        marginBottom: '24px',
        lineHeight: 1
      }}>
        404
      </div>
      
      <h1 style={{
        fontSize: '36px',
        marginBottom: '16px',
        color: '#333'
      }}>
        Page Not Found
      </h1>
      
      <p style={{
        fontSize: '18px',
        color: '#666',
        maxWidth: '600px',
        marginBottom: '32px'
      }}>
        The page you are looking for might have been removed, had its name changed,
        or is temporarily unavailable.
      </p>
      
      <Link 
        to="/"
        style={{
          backgroundColor: '#003366',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '4px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: 'bold',
          transition: 'background-color 0.3s'
        }}
      >
        Back to Dashboard
      </Link>
    </div>
  );
};

export default NotFoundPage;
